import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const dismissRmaCreationFailure = {
  name: "dismissRmaCreationFailure" as const,
  input: z.object({ returnId: zExt.objectId(), integrationName: z.string() }),
  output: z.null(),
};
